import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { gql } from "@apollo/client";
import { PLAYBACK_SESSION_ERROR_CODES, PLAYBACK_SESSION_ERROR_MESSAGES, PLAYBACK_ERROR_MESSAGES } from "@/lib/errors";
export const typeDef = gql`
  type Playback @cacheControl(scope: PRIVATE, maxAge: 0) {
    media: PlaybackMedia
    rule: PlaybackRule
    playback_session_id: String
    log_params: JSONObject
    error: PlaybackError
    mediaSource: JSONObject
    resumePoint: Int
    entitlements: [Entitlement]
  }

  type PlaybackMedia @cacheControl(scope: PRIVATE, maxAge: 0) {
    media_id: ID!
    uuid: String
    ovp_id: Int
    ovp_video_id: String
    thumbnail_tile_urls: [String]
  }

  type PlaybackRule {
    playback_rule_id: ID
    enable_seek_flag: Boolean
    enable_cromecst_flag: Boolean
    enable_airplay_flag: Boolean
    enable_mirroring_flag: Boolean
    enable_external_monitor_flag: Boolean
    enable_catchup_flag: Boolean
    enable_start_over_flag: Boolean
    enable_pause_flag: Boolean
    enable_background_play_flag: Boolean
    enable_screen_capture_flag: Boolean
    enable_playback_rate_change_flag: Boolean
    enable_offline_play_flag: Boolean
    maximum_bitrate: Int
    minimum_bitrate: Int
  }

  type PlaybackError {
    type: String
    message: String
    code: Int
  }

  type MediaSource @cacheControl(maxAge: 0) {
    media: JSONObject
    error: PlaybackError
  }

  type PlaybackSessionCheckResult {
    result: Boolean
  }

  type PlaybackSessionCloseResult {
    result: Boolean
  }

  type Query {
    playbackAuth(id: Int, vuid: String, sessionId: String, fl: Int): Playback
  }

  type Mutation {
    playbackSessionOpen(videoId: String, sessionId: String): MediaSource
    playbackSessionCheck(sessionId: String): PlaybackSessionCheckResult
    playbackSessionClose(sessionId: String): PlaybackSessionCloseResult
  }
`;
export const resolvers = {
  Query: {
    playbackAuth: async (_parent, _ref, _ref2) => {
      let {
        id,
        vuid,
        sessionId,
        fl
      } = _ref;
      let {
        dataSources
      } = _ref2;
      try {
        const playback = await dataSources.playbackAuth.auth({
          id,
          vuid,
          sessionId,
          fl,
          withResumePoint: true,
          exercise: true
        });
        const {
          entitlements
        } = await dataSources.user.entitlementsFromMeta(id);
        return _objectSpread(_objectSpread({}, playback), {}, {
          entitlements
        });
      } catch (e) {
        var _e$extensions;
        console.log("playback error", JSON.stringify(e.extensions, null, 2));
        // TODO: 同時視聴制限などエラーハンドリング
        if (((_e$extensions = e.extensions) === null || _e$extensions === void 0 || (_e$extensions = _e$extensions.response) === null || _e$extensions === void 0 || (_e$extensions = _e$extensions.body) === null || _e$extensions === void 0 || (_e$extensions = _e$extensions.error) === null || _e$extensions === void 0 ? void 0 : _e$extensions.code) == 2050) {
          e.extensions.response.body.error.message = PLAYBACK_ERROR_MESSAGES[2050];
        }
        return e.extensions.response.body;
      }
    }
  },
  Mutation: {
    playbackSessionOpen: async (_parent, _ref3, _ref4) => {
      let {
        videoId,
        sessionId
      } = _ref3;
      let {
        dataSources
      } = _ref4;
      try {
        const mediaSource = await dataSources.playbackSession.open(videoId, sessionId);
        return {
          media: mediaSource
        };
      } catch (e) {
        var _response$body;
        console.log("playback session error", JSON.stringify(e.extensions, null, 2));
        const response = e.extensions.response;
        if ((response.status === 400 || response.status === 403) && response !== null && response !== void 0 && (_response$body = response.body) !== null && _response$body !== void 0 && _response$body.error) {
          var _response$body2, _response$body5, _response$body6;
          // エラーレスポンスに複数パターンがある?
          const errorCode = Number((_response$body2 = response.body) === null || _response$body2 === void 0 ? void 0 : _response$body2.error);
          if (!isNaN(errorCode)) {
            var _response$body3, _response$body4;
            return {
              error: {
                type: (_response$body3 = response.body) === null || _response$body3 === void 0 ? void 0 : _response$body3.type,
                message: (_response$body4 = response.body) === null || _response$body4 === void 0 ? void 0 : _response$body4.message,
                code: errorCode
              }
            };
          } else if ((response === null || response === void 0 || (_response$body5 = response.body) === null || _response$body5 === void 0 ? void 0 : _response$body5.result) === false && typeof (response === null || response === void 0 || (_response$body6 = response.body) === null || _response$body6 === void 0 ? void 0 : _response$body6.error) === "string") {
            var _response$body7, _response$body8, _response$body9, _response$body10;
            const message = PLAYBACK_SESSION_ERROR_MESSAGES[PLAYBACK_SESSION_ERROR_CODES[response === null || response === void 0 || (_response$body7 = response.body) === null || _response$body7 === void 0 ? void 0 : _response$body7.error]] || (response === null || response === void 0 || (_response$body8 = response.body) === null || _response$body8 === void 0 ? void 0 : _response$body8.error);
            const code = PLAYBACK_SESSION_ERROR_CODES[response === null || response === void 0 || (_response$body9 = response.body) === null || _response$body9 === void 0 ? void 0 : _response$body9.error] || PLAYBACK_SESSION_ERROR_CODES["other"];
            return {
              error: {
                type: (_response$body10 = response.body) === null || _response$body10 === void 0 ? void 0 : _response$body10.type,
                message,
                code
              }
            };
          }
        } else {
          throw e;
        }
      }
    },
    playbackSessionCheck: async (_parent, _ref5, _ref6) => {
      let {
        sessionId
      } = _ref5;
      let {
        dataSources
      } = _ref6;
      const result = await dataSources.playbackSession.check(sessionId);
      return result;
    },
    playbackSessionClose: async (_parent, _ref7, _ref8) => {
      let {
        sessionId
      } = _ref7;
      let {
        dataSources
      } = _ref8;
      // TODO: 他のデバイスでクローズされたときにエラーになる？？
      try {
        const result = await dataSources.playbackSession.close(sessionId);
        return result;
      } catch (e) {
        console.log(e);
        return false;
      }
    }
  },
  Playback: {
    rule: playback => playback.playback_rule,
    resumePoint: playback => playback.resume_point
  }
};